<template lang="html">
  <div v-if="projectEditLoading" class="centered">
    <loader />
  </div>
  <v-app  v-else class="white large-screen__body">
    <v-toolbar dark tabs>
      <v-btn icon @click = "goBack">
        <img src="~icons/backIcon/backIcon.png" alt="backIcon">
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text pr-4">
        EDIT PROJECT {{ project.project_ref }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div class="body mt-2">
      <v-container fluid  grid-list-md>
        <div class="gray--background pa-3 mb-4">
          <v-layout row wrap v-if="status === 0 || !status">
            <v-flex xs12 sm10 class="mt-2">
              <span class="caption">Your project is pending and isn't published live.</span>
            </v-flex>
            <v-flex xs12 sm2 class="center">
              <v-btn class="publish white--text" large right round @click="setStatus('1')">Publish</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else-if="status === 1">
            <v-flex xs12 sm10 class="mt-2">
              <span class="caption">Your Project is currently Live and available to Users eligible to discover it.</span>
            </v-flex>
            <v-flex xs12 sm2 class="center">
              <v-btn class="publish white--text" right round @click="setStatus('0')">Pause</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else-if="status === 2">
            <v-flex xs12 sm10 class="mt-2">
              <span class="caption">Your Project is currently being Completed by Users.</span>
            </v-flex>
            <v-flex xs12 sm2 class="center">
              <v-btn class="publish white--text" right round @click="setStatus('0')">Pause</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else-if="status === 3">
            <v-flex xs12 sm10 class="mt-2">
              <span class="caption">Your Project has reached the criteria for being Completed.</span>
            </v-flex>
            <v-flex xs12 sm2  class="center">
              <v-btn class="publish white--text" right round @click="setStatus('4')">Archive</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else-if="status >= 4">
            <v-flex  xs12 sm12 md12 class="mt-2">
              <span class="caption">Your Project is currently archived.</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else>
            <v-flex xs12 sm10 class="mt-2">
              <span class="caption">Your project is pending and isn't published live.</span>
            </v-flex>
            <v-flex xs12 sm2 class="center">
              <v-btn class="publish white--text" large right round @click="setStatus('1')">Publish</v-btn>
            </v-flex>
          </v-layout>
        </div>

        <!-- title input -->
        <v-layout row wrap>
          <v-flex xs12 sm8>
            <v-layout row wrap class="input-container mb-24 mr-3">
              <v-flex xs12 sm3>
                <label for="Title">Title<sup class="red--text">*</sup></label>
              </v-flex>
              <v-flex xs12 sm9>
                <input
                  type="text"
                  size="45"
                  placeholder="Short title that explains the effort"
                  v-model="name"
                />
              </v-flex>
              <character-count :text="name" :min="20"/>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm4>
            <v-btn-toggle mandatory v-model="taskVirtual">
              <v-btn icon value="1" title="Things that can be performed anywhere by anyone.">
                Virtual
              </v-btn>
              <v-btn icon value="0" title="Things that can be performed if you're within the location radius">
                Local
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2>
            <label for="project-organizer">Project Organizers</label>
          </v-flex>
          <v-flex xs12 sm10 class="pa-0">
            <v-select
              solo
              multiple
              cache-items
              autocomplete
              return-object
              class="select"
              placeholder="Type to search for an effort organizer. You will be auto added."
              :search-input.sync="projectOrganizerInput"
              :items="users"
              item-text="username"
              item-value="user_id"
              v-model="projectsOrganizers"
              >
            </v-select>
          </v-flex>
        </v-layout>
        <!-- task description -->
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2 md2>
            <label for="Description">Description <sup class="red--text">*</sup></label>
          </v-flex>
          <v-flex xs12 sm10 md10>
            <textarea
              placeholder="Enter as much background information on this Project and its Goal and Scopes."
              v-model="description"
            ></textarea>
          </v-flex>
          <character-count :text="description" :min="50"/>
        </v-layout>

        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2>
            <label for="Categories">Categories<sup class="red--text">*</sup></label>
          </v-flex>
          <v-flex xs12 sm10 class="pa-0">
            <v-select
              multiple
              class="select"
              solo
              placeholder="Select a category"
              item-text="category_name"
              item-value="category_id"
              :items="categoryOptions"
              v-model="categories"
            >
            </v-select>
          </v-flex>
        </v-layout>

        <!-- file upload -->
        <v-layout row wrap>
          <v-flex xs12 sm3 md2 class="pa-0 pb-3">
            <v-btn class="upload"  @click="onFilePick">Upload File<sup class="red--text">*</sup></v-btn>
            <input
              @change="onFilePicked"
              type="file"
              accept="*/*"
              style="display: none;"
              ref="upload"
            >
          </v-flex>
          <div class="media-section">
            <v-layout row class="mb-2">
              <span class="pl-3 pt-3"> or
                <v-btn
                  small
                  flat
                  color=blue
                  :ripple="false"
                  @click.native.stop="dialog = true"
                >
                  <span class="add-media-text">add media from the web</span>
                </v-btn>
                Drag’n’drop media files to re-order them.
              </span>
            </v-layout>
            <v-dialog v-model="dialog" max-width="736px">
              <v-card class="card web-media">
                <v-layout justify-center>
                  <div class="web-media-text mt-4 mb-2 mx-4">YouTube, Vimeo, and direct links to MOV and MPEG files will work.</div>
                </v-layout>
                <v-layout row wrap class="input-container mt-2 mb-4">
                  <v-flex xs12 sm12 md3>
                    <label for="Media">link</label>
                  </v-flex>
                  <v-flex xs12 sm12 md9>
                    <input
                      type="text"
                      placeholder="https:\\your-website.com"
                      v-model="url"
                      >
                     </input>
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-btn class="publish white--text mb-24"  @click="addMediaUrl(url)" right round>Add Link</v-btn>
                </v-layout>
              </v-card>
            </v-dialog>
          </div>
        </v-layout>

        <container @drop="sortMedias" orientation="horizontal" style="white-space: unset;">
          <draggable v-for="(image, index) in medias" :key="image.data_object_id">
            <span @click="showGallery(index)" class="image-list">
              <imager :src="createThumbnailUrl(image.data_url)" :styles="{'min-width': '124px', 'max-height': '124px'}">
                <loader></loader>
              </imager>
              <v-btn icon class="image-list-button" @click.stop="removeProjectMediaObject(index)">
                <i class="delete-icon"></i>
              </v-btn>
            </span>
          </draggable>
        </container>
      </v-container>
    </div>
  </v-app>
</template>


<script>

import { mapActions } from 'vuex';
import { Container, Draggable } from 'vue-smooth-dnd';
import { applyDrag } from '@/utils/dnd';

import Imager from '@/components/Imager';
import Loader from '@/components/Loader';

import CharacterCount from '@/components/shared/CharacterCount';

import uploader from '@/mixins/uploader';
import { identifyFileType, FILE_TYPES } from '@/utils/file_type';

import audioThumbnail from 'icons/audio-thumbnail.png';
import videoThumbnail from 'icons/video-thumbnail.png';
import documentThumbnail from 'icons/document-thumbnail.png';


export default {
  mixins: [uploader],
  components: {
    Container,
    Draggable,
    CharacterCount,
    Imager,
    Loader,
  },
  data() {
    return {
      toggle_none: null,
      dialog: false,
      url: null,
      projectOrganizerInput: null,
    };
  },
  methods: {
    ...mapActions({
      searchUsers: 'users/searchUsers',
    }),
    sortMedias({ removedIndex, addedIndex }) {
      this.medias = applyDrag(this.medias, removedIndex, addedIndex);
    },
    createOrUpdateProject(project) {
      this.$store.dispatch('projects/editProject', {
        ...project,
        project_id: this.id,
      });
    },
    onFilePick() {
      this.$refs.upload.click();
    },
    setStatus(value) {
      if (value === '1') {
        // check required task name
        if (!this.name) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Project name is required before you can publish it.',
            type: 'error',
          });
          return;
        }

        if (this.name.length < 20) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Project name should be at least 20 characters long',
            type: 'error',
          });
          return;
        }

        // check required task description
        if (!this.description) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Project description is required before task can be published',
            type: 'error',
          });
          return;
        }

        if (this.description.length < 50) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Project description should be at least 50 characters long',
            type: 'error',
          });
          return;
        }

        // check required categories
        if (!this.categories.length) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Please select at least one category before you publish the project',
            type: 'error',
          });
          return;
        }

        // check required media
        if (!this.medias.length) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Please add at least one media item before you publish the project',
            type: 'error',
          });
          return;
        }
      }

      this.status = value;
    },
    showGallery(index) {
      this.$store.dispatch('gallery/showGallery', { show: true, active: index });
    },
    goBack() {
      this.$router.go(-1);
    },
    onFilePicked(event) {
      const files = event.target.files;
      const file = files[0];
      // TODO: what to do while the image is loading
      // upload function is present in the upload mixin
      this.uploadMedia(file, { project_id: this.id })
        .then((mediaObject) => {
          this.addProjectMediaObject(mediaObject);
        });
    },
    addProjectMediaObject(mediaObject) {
      // add the new media to the list of media
      this.$store.dispatch('projects/projectsObjectAdd', mediaObject);
    },
    removeProjectMediaObject(index) {
      // TODO: remove the task object from the backend
      // remove the task media from the list
      this.$store.dispatch('projects/projectsMediaObjectRemove', {
        index,
        projectId: this.id,
      });
    },
    addMediaUrl(url) {
      if (!url) {
        return;
      }
      this.$store.dispatch('projects/addMediaUrl', { projects_data: [{ data_url: url }], project_id: this.id });
      this.url = ''; // to make the url field empty
      this.dialog = !this.dialog;
    },
    createThumbnailUrl(url) {
      const fileType = identifyFileType(url);
      switch (fileType) {
        case FILE_TYPES.IMAGE:
          return url;
        case FILE_TYPES.VIDEO:
          return videoThumbnail;
        case FILE_TYPES.AUDIO:
          return audioThumbnail;
        default:
          return documentThumbnail;
      }
    },
  },
  computed: {
    projectEditLoading() {
      return this.$store.getters['projects/projectEditLoading'];
    },
    id() {
      return this.$route.params.id;
    },
    users() {
      return [
        ...this.projectsOrganizers,
        ...this.$store.getters['users/list'],
      ];
    },
    projectsOrganizers: {
      get() { return this.$store.getters['projects/organizers']; },
      set(value) { this.$store.dispatch('projects/editOrganizers', { project_id: this.id, projects_organizers: value }); },
    },
    project() {
      return this.$store.getters['projects/project'];
    },
    name: {
      get() { return this.project.project_name; },
      set(value) { this.createOrUpdateProject({ project_name: value }); },
    },
    description: {
      get() { return this.project.project_description; },
      set(value) { this.createOrUpdateProject({ project_description: value }); },
    },
    taskVirtual: {
      get() { return this.project.project_virtual; },
      set(value) { this.createOrUpdateProject({ project_virtual: value }); },
    },
    status: {
      get() { return parseInt(this.project.project_status, 10); },
      set(value) {
        this.createOrUpdateProject({ project_status: value });
      },
    },
    medias: {
      get() {
        const images = this.$store.getters['projects/medias'];
        const imageUrls = [];
        for (let i = 0; i < images.length; i += 1) {
          imageUrls.push(images[i].data_url);
        }
        this.$store.dispatch('gallery/setImages', imageUrls);
        return images;
      },
      set(medias) { this.$store.dispatch('projects/reorderProjectMedia', { medias, projectId: this.id }); },
    },
    categories: {
      get() { return this.$store.getters['projects/categories']; },
      set(value) {
        const filteredArray = this.categoryOptions.filter(itm =>
          value.indexOf(itm.category_id) > -1);
        this.$store.dispatch('projects/editCategories', { project_id: this.id, projects_categories: filteredArray });
      },
    },
    categoryOptions() {
      return this.$store.getters['projects/categoryOptions'];
    },
  },
  watch: {
    projectOrganizerInput(val) {
      if (val && val.length >= 3) {
        this.searchUsers(val);
      }
    },
  },
  mounted() {
    this.$store.dispatch('projects/resetProjectsState');
    this.$store.dispatch('projects/getProjectEditDetails', { projectId: this.id });
    this.$store.dispatch('projects/getProjectEditDefaults');
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

#app {
  input {
    width:100%;
    font-size:16px;
  }

  .image-list {
    position: relative;
    display:inline-block;
    padding:1px;
  }

  .image-list .image-list-button {
    background: $white;
    position: absolute;
    right: 0;
    bottom: 0;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .hidden {
    background: linear-gradient(to right, #ffd677, #ff2e64);
    text-align: center;
  }

  ::placeholder {
    font-size: 16px;
    color: $placeholder;
  }

  .adddivider {
    border-bottom: 0.5px solid rgb(229,229,229);
  }

  .media-section {
    .btn {
      color: $blue;
    }
    .add-media-text {
      color: $blue;
    }
  }

  .web-media {
    height: fit-content;
    border-radius: 12px;
    background-color: #ffffff;

    .input-container {
      width:80%;
      max-width:519px;
      margin: auto;
      box-shadow: 0 2px 6px 0.5px $border-color;
      input:focus , textarea:focus {
        outline: none;
      }
      .web-media-text {
        font-size: 10px;
        letter-spacing: normal;
        text-align: left;
        color: $blue;
      }
    }
  }

  p {
    margin:0;
    text-align: center;
    text-transform: uppercase;
    font-size:18px;
    font-family: MuseoSansRounded-1000;
  }

  @media only screen and (min-width: 900px) {
    .container {
      max-width: 100%;
    }
  }

  .completion-question {
    word-wrap: break-word;
  }

  .body {
    padding-top:10px;
    padding-left: 24px;
    padding-right:24px;
    background: white;
  }

  .gray--background {
    background-color:  $lighter;
  }

  .publish {
    background: $primary;
    font-family: MuseoSans-900;
    font-size: 16px !important;
    text-align: center;
    padding: 1px;
  }

  .mb-24 {
    margin-bottom: 24px;
  }

  .input-container input:focus, .input-container textarea:focus {
    outline: none;
  }

  .input-container textarea {
    width: 100%;
  }

  .upload {
    width: 100%;
    border-radius:28px 28px 28px 28px;
    min-height: 48px;
    box-shadow: 0 2px 6px 0.5px $border-color;
    margin-bottom: 10px;
    background-color: white;
    color: $blue;
  }

  .input-container label, .input-container label{
    color: $blue;
    font-family: MuseoSans-500;
    font-size: 16px;
  }
  .input-container textarea {
    font-size: 16px;
    font-family: MuseoSans-500;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectEdit.vue